import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/feature/ArticleCard';
import PopularSidebar from '@/components/feature/PopularSidebar';
import { categories } from '@/mocks/categories';
import { articles, popularArticles } from '@/mocks/articles';

const categoryNameMap: Record<string, string> = {};
categories.forEach((c) => { categoryNameMap[c.slug] = c.name; });

const heroArticles = articles.slice(0, 3);
const latestArticles = articles.slice(3);

export default function Home() {
  const [activeCat, setActiveCat] = useState('all');
  const filteredArticles = activeCat === 'all'
    ? latestArticles
    : latestArticles.filter((a) => a.category === activeCat);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料网吃瓜',
    url: 'https://heiliao.com',
    description: '黑料网吃瓜是娱乐爱好者获取最新明星爆料、网红黑料、热门瓜的首选平台。汇聚全网最新最劲爆的吃瓜资讯，实时更新热点事件。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliao.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料网吃瓜',
    url: 'https://heiliao.com',
    description: '汇聚全网最新最劲爆的吃瓜资讯平台',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Banner */}
          <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20red%20carpet%20scene%20with%20paparazzi%20camera%20flashes%2C%20Hollywood%20glamour%20vibe%2C%20spotlights%20and%20dramatic%20shadows%2C%20dark%20cinematic%20atmosphere%20with%20warm%20golden%20accents%2C%20mysterious%20and%20elegant%20aesthetic%2C%20high%20contrast%20editorial%20photography&width=1600&height=800&seq=hero-banner-01&orientation=landscape"
              alt="黑料网吃瓜 - 最新娱乐爆料"
              title="黑料网吃瓜 - 最新娱乐爆料聚合平台"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center w-full px-4 text-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 max-w-3xl leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                黑料网吃瓜
              </h1>
              <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
                汇聚全网最新最劲爆的吃瓜资讯，实时更新热点事件，让你第一时间吃到最新鲜的瓜
              </p>
              <div className="flex items-center gap-3 flex-wrap justify-center">
                <Link
                  to="/category/zuixin"
                  className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  最新瓜报
                </Link>
                <Link
                  to="/category/mingxing"
                  className="px-6 py-2.5 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
                >
                  明星爆料
                </Link>
              </div>
            </div>
          </section>

          {/* Category Tabs */}
          <section className="w-full px-4 md:px-6 py-8">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 flex-wrap">
                <button
                  onClick={() => setActiveCat('all')}
                  className={`px-4 py-2 text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                    activeCat === 'all'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                  }`}
                >
                  全部
                </button>
                {categories.map((cat) => (
                  <button
                    key={cat.slug}
                    onClick={() => setActiveCat(cat.slug)}
                    className={`px-4 py-2 text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                      activeCat === cat.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                    }`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </button>
                ))}
              </div>
            </div>
          </section>

          {/* Hero Articles Grid */}
          <section className="w-full px-4 md:px-6 pb-8">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {heroArticles.map((article) => (
                  <ArticleCard
                    key={article.slug}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    coverImage={article.coverImage}
                    category={article.category}
                    categoryName={categoryNameMap[article.category] || article.category}
                    publishedAt={article.publishedAt}
                    views={article.views}
                    tags={article.tags}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* Main Content + Sidebar */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8">
              {/* Articles List */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-5">
                  <h2 className="text-lg font-bold text-foreground-950">
                    {activeCat === 'all' ? '最新资讯' : categoryNameMap[activeCat]}
                  </h2>
                  <Link
                    to={activeCat === 'all' ? '/category/zuixin' : `/category/${activeCat}`}
                    className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
                  >
                    查看更多
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </Link>
                </div>

                {filteredArticles.length === 0 ? (
                  <div className="text-center py-16 text-foreground-500">
                    <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                      <i className="ri-inbox-line text-4xl text-foreground-300"></i>
                    </div>
                    <p>该分类暂无更多文章</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {filteredArticles.map((article) => (
                      <ArticleCard
                        key={article.slug}
                        slug={article.slug}
                        title={article.title}
                        excerpt={article.excerpt}
                        coverImage={article.coverImage}
                        category={article.category}
                        categoryName={categoryNameMap[article.category] || article.category}
                        publishedAt={article.publishedAt}
                        views={article.views}
                        tags={article.tags}
                      />
                    ))}
                  </div>
                )}
              </div>

              {/* Sidebar */}
              <aside className="w-full lg:w-[320px] shrink-0">
                <PopularSidebar items={popularArticles} />
              </aside>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}